import bowser from 'yola-bowser';
import { getClosestScrollableElement } from 'anodum';

const getScrollableElement = (document) => {
  if (bowser.ios && !bowser.isIpadOS) {
    return getClosestScrollableElement(document.defaultView.frameElement.parentElement, false);
  }

  const targetDocument = bowser.isIpadOS
    ? document.defaultView.frameElement.ownerDocument
    : document;
  return targetDocument.scrollingElement;
};

export default getScrollableElement;
